import React, { useEffect, useRef } from 'react';

import './index.css';

const Landing: React.FC = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    // Load external Framer scripts
    const loadFramerAssets = async () => {
      // Load the main Framer module
      try {
        const script = document.createElement('script');
        script.type = 'module';
        script.src =
          'https://framerusercontent.com/sites/3GQ6MKe6U70jQKs23UcTgU/script_main.QZYJDZ56.mjs';
        script.async = true;
        script.setAttribute('data-framer-bundle', 'main');
        document.head.appendChild(script);

        // Add the animator script
        const animatorScript = document.createElement('script');
        animatorScript.innerHTML = `
          // Include the full animator code from your file here
          var animator = (() => {
            // ... animator implementation
            return {
              animateAppearEffects: () => {},
              getActiveVariantHash: () => {},
              spring: () => {},
              startOptimizedAppearAnimation: () => {}
            };
          })();
        `;
        document.head.appendChild(animatorScript);

        // Initialize animations after scripts load
        setTimeout(() => {
          initializeAnimations();
        }, 100);
      } catch (error) {
        // Failed to load Framer assets
      }
    };

    const initializeAnimations = () => {
      // Set up the animation data
      // @ts-ignore
      window.__framer__appearAnimationsContent = {
        text: JSON.stringify({
          '1pwzcna': {
            default: {
              initial: {
                opacity: 0.001,
                scale: 0.8,
                transformPerspective: 1200,
              },
              animate: {
                opacity: 1,
                scale: 1,
                transition: {
                  damping: 30,
                  delay: 0,
                  mass: 1,
                  stiffness: 300,
                  type: 'spring',
                },
              },
            },
          },
        }),
      };

      // Trigger animations
      // @ts-ignore
      if (window.animator && containerRef.current) {
        // @ts-ignore
        const elements = containerRef.current.querySelectorAll(
          '[data-framer-appear-id]'
        );
        // @ts-ignore
        elements.forEach(element => {
          // Apply initial styles
          element.style.opacity = '0.001';
          element.style.transform = 'scale(0.8)';

          // Animate to final state
          setTimeout(() => {
            element.style.transition =
              'all 0.6s cubic-bezier(0.23, 1, 0.32, 1)';
            element.style.opacity = '1';
            element.style.transform = 'scale(1)';
          }, 100);
        });
      }
    };

    loadFramerAssets();

    return () => {
      // Cleanup
      const scripts = document.querySelectorAll('script[data-framer-bundle]');
      scripts.forEach(script => script.remove());
    };
  }, []);

  return (
    <div
      ref={containerRef}
      // dangerouslySetInnerHTML={{ __html: landingHtml }}
    />
  );
};

export default Landing;
